import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Unternehmensbewertung() {
	return (
		<>
			<div className="beratung_cont" id="profiling">
				<HelmetProvider>
					<Helmet>
						<title>Beratung bei der Unternehmensbewertung</title>
						<meta
							name="description"
							content="Beratung bei der Unternehmensbewertung"
						/>
						<meta
							name="keywords"
							content="Unternehmensbewertung, Assets , Feingeist, Berlin"
						/>
					</Helmet>
				</HelmetProvider>
				<h1>Beratung bei der Unternehmensbewertung</h1>
				<h2>Werte messbar machen</h2>
				<p>Die Feingeist Beratung quantifiziert Ihre Assets.</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>Unabhängige Drittmeinung</li>
					<li>Bewertung nach anerkannten Verfahren</li>
				</ul>
				<p>
					Eine Unternehmensbewertung kann in verschiedenen Situation bspw. zur
					Objektivierung (Erbschaft, Schenkung), Bemessungsgrundlage
					(Bilanzierung) oder zur Argumentation (Verhandlung) vorteilhaft sein.
				</p>
				<p>Die Gründe für eine Unternehmensbewertung sind vielfältig:</p>
				<ul className="typeset-u-list">
					<li>
						Unternehmensverkauf im Rahmen einer Nachfolge an oder aus anderen
						Gründen
					</li>
					<li>Ausscheiden eines Gesellschafters</li>
					<li>Abspaltung von Unternehmensteilen</li>
					<li>Steuerliche Anlässe (Erbschaft, Schenkung, etc)</li>
					<li>
						Gespräche mit Banken oder Investoren (bspw. bei Aufnahme von Fremd-
						oder Eigenkapital)
					</li>
				</ul>
				<p>Sprechen Sie uns an.</p>

				<h2 className="hd-center">Beratungsprodukte</h2>
				<div className="downloads single_item">
					<div className="download_pdf">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2023/12/die_unternehmensbewertung_der_feingeist_beratung.pdf">
							<div className="image_potrait die_unternehmensbewertung"></div>

							<div className="ebook-desc">
								<h3>
									Broschüre: Unternehmensbewertung durch die Feingeist Beratung
								</h3>
							</div>
						</a>
					</div>
				</div>
			</div>
		</>
	);
}
